export default "__VITE_ASSET__CFrGx426__"